import { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import axios from "axios";
import "@/App.css";
import LandingPage from "@/pages/LandingPage";
import Dashboard from "@/pages/Dashboard";
import Cases from "@/pages/Cases";
import LegalAI from "@/pages/LegalAI";
import ContractGenerator from "@/pages/ContractGenerator";
import AskLawyer from "@/pages/AskLawyer";
import Appointments from "@/pages/Appointments";
import CaseAnalyzer from "@/pages/CaseAnalyzer";
import Reports from "@/pages/Reports";
import Notes from "@/pages/Notes";
import ContactUs from "@/pages/ContactUs";

import AdminDashboard from "@/pages/AdminDashboard";
import AdminLogin from "@/pages/AdminLogin";
import InstallPrompt from "@/components/InstallPrompt";
import { Toaster } from "@/components/ui/sonner";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      fetchUser();
    } else {
      setLoading(false);
    }
  }, []);

  const fetchUser = async () => {
    try {
      const response = await axios.get(`${API}/auth/me`);
      setUser(response.data.user);
    } catch (error) {
      console.error("Error fetching user:", error);
      localStorage.removeItem("token");
      delete axios.defaults.headers.common['Authorization'];
    } finally {
      setLoading(false);
    }
  };

  const handleLogin = (token, userData) => {
    localStorage.setItem("token", token);
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    setUser(userData);
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    delete axios.defaults.headers.common['Authorization'];
    setUser(null);
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-50 to-blue-50">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-700 mx-auto"></div>
          <p className="mt-4 text-slate-600">جاري التحميل...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={user ? <Navigate to="/dashboard" /> : <LandingPage onLogin={handleLogin} />} />
          <Route
            path="/dashboard"
            element={user ? <Dashboard user={user} onLogout={handleLogout} /> : <Navigate to="/" />}
          />
          <Route
            path="/cases"
            element={user ? <Cases user={user} onLogout={handleLogout} /> : <Navigate to="/" />}
          />
          <Route
            path="/legal-ai"
            element={user ? <LegalAI user={user} onLogout={handleLogout} /> : <Navigate to="/" />}
          />
          <Route
            path="/contract-generator"
            element={user ? <ContractGenerator user={user} onLogout={handleLogout} /> : <Navigate to="/" />}
          />
          <Route
            path="/appointments"
            element={user ? <Appointments user={user} onLogout={handleLogout} /> : <Navigate to="/" />}
          />
          <Route
            path="/case-analyzer"
            element={user ? <CaseAnalyzer user={user} onLogout={handleLogout} /> : <Navigate to="/" />}
          />
          <Route
            path="/reports"
            element={user ? <Reports user={user} onLogout={handleLogout} /> : <Navigate to="/" />}
          />
          <Route
            path="/notes"
            element={user ? <Notes user={user} onLogout={handleLogout} /> : <Navigate to="/" />}
          />
          <Route
            path="/contact"
            element={user ? <ContactUs user={user} onLogout={handleLogout} /> : <Navigate to="/" />}
          />
          {/* Subscription removed - platform is free */}
          <Route path="/subscription" element={<Navigate to="/dashboard" />} />
          <Route
            path="/tmkn-admin"
            element={<AdminLogin onLogin={handleLogin} />}
          />
          <Route
            path="/tmkn-admin/dashboard"
            element={user ? <AdminDashboard user={user} onLogout={handleLogout} /> : <Navigate to="/tmkn-admin" />}
          />
        </Routes>
      </BrowserRouter>
      <InstallPrompt />
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
